"use client"

import { useEffect, useState, useTransition } from "react"
import { useRouter } from "next/navigation"
import { updateLocale } from "@lib/data/locale-actions"

const STORAGE_KEY = "site-language-selected"

const LANGUAGES = [
  { code: "en-US", label: "English" },
  { code: "ru-RU", label: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439" },
  { code: "he-IL", label: "\u05e2\u05d1\u05e8\u05d9\u05ea" },
]

function getUiText(locale: string | null) {
  if (locale === "ru-RU") {
    return {
      title: "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u044f\u0437\u044b\u043a",
      subtitle:
        "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u044f\u0437\u044b\u043a \u0441\u0430\u0439\u0442\u0430",
    }
  }

  if (locale === "he-IL") {
    return {
      title: "\u05d1\u05d7\u05e8 \u05e9\u05e4\u05d4",
      subtitle:
        "\u05d0\u05e0\u05d0 \u05d1\u05d7\u05e8 \u05d0\u05ea \u05e9\u05e4\u05ea \u05d4\u05d0\u05ea\u05e8",
    }
  }

  return {
    title: "Choose language",
    subtitle: "Please select your preferred language",
  }
}

export default function LanguageFirstVisitModal() {
  const [open, setOpen] = useState(false)
  const [currentLocale, setCurrentLocale] = useState<string | null>(null)
  const [isPending, startTransition] = useTransition()
  const router = useRouter()

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY)

    if (saved) {
      setCurrentLocale(saved)
    } else {
      setOpen(true)
    }

    const openModal = () => {
      const localeNow = localStorage.getItem(STORAGE_KEY)
      setCurrentLocale(localeNow)
      setOpen(true)
    }

    window.addEventListener("open-language-modal", openModal)

    return () => {
      window.removeEventListener("open-language-modal", openModal)
    }
  }, [])

  const handleSelect = (locale: string) => {
    startTransition(async () => {
      await updateLocale(locale)
      localStorage.setItem(STORAGE_KEY, locale)
      setCurrentLocale(locale)
      setOpen(false)
      router.refresh()
    })
  }

  if (!open) return null

  const ui = getUiText(currentLocale)
  const isHebrew = currentLocale === "he-IL"

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div
        dir={isHebrew ? "rtl" : "ltr"}
        className="w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl"
      >
        <h2 className="text-center text-xl font-semibold text-black">
          {ui.title}
        </h2>

        <p className="mt-2 text-center text-sm text-gray-600">
          {ui.subtitle}
        </p>

        <div className="mt-6 flex flex-col gap-3">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              disabled={isPending}
              className="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-base font-medium text-black hover:bg-gray-50 disabled:opacity-60"
            >
              {lang.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}